/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./style.scss";
import { Row, Col, Button, Modal, Tooltip, notification, message } from "antd";
import TableContainer from "../../../components/TableContainer";
import API from "../../../api";
import urls from "../../../api/urls";
import moment from "moment";
import { getSingleBooking } from "../../../actionsMethods/cashBookingMethods";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ViewBookingSummary from "../../ViewBookingSummary";
import PRSAssignDA from '../PRSAssignDA/PRSAssignDA';
import { ReactComponent as DaEditIcon } from "../../../assests/images/SVG/da_edit.svg";
import { ReactComponent as DaIcon } from "../../../assests/images/SVG/da_icon.svg";
import Heading from "../../../components/Heading";
import constants from "../../../constants/constants";

const { PRS_LIST } = urls;
const { DP_OPERATOR } = constants.ROLES;

const prsStatus = {
  PRS_PENDING: 'PRS Pending',
  PRS_ASSIGN_TO_DA: 'PRS Assign to DA',
  PRS_IN_PROGRESS: 'PRS In Progress',
  PRS_PARTIAL_PICKEDUP: 'PRS Partial Picked Up',
  PRS_PICKEDUP : 'PRS Picked Up',
  PRS_DELIVERED_AT_HUB : 'PRS Delivered at Hub',
  PRS_FAILED_TO_PICKUP : 'PRS Failed to Pick Up',
  PRS_DELIVERED_EXTERNALLY : 'PRS Delivered Externally'
};

const CpPrsDetails = () => {
  const { id } = useParams();
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [prsDetails, setPrsDetails] = useState({});
  const [bookingType, setBookingType] = useState("");
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);
  const componentRef = useRef();
  const dispatch = useDispatch();
  const viewBookingSummaryResponse = useSelector(
    (state) => state.appReducer.getSingleBookingReducer,
    shallowEqual
  );
  const [isAssignDAModalOpen, setIsAssignDAModalOpen] = useState(false);
  const [selectedPRS, setSelectedPRS] = useState(null);

  // Check if current user has DP_OPERATOR role
  const userRoles = JSON.parse(localStorage.getItem("userinfo"))?.roles || [];
  const isDPOperator = userRoles.includes(DP_OPERATOR);

  const {
    result: singleResult,
    error,
    fetching: loading2,
  } = viewBookingSummaryResponse;

  const handleEyeButton = (b) => {
    setBookingType(b?.bookingType);
    setIsSummaryModalOpen(true);
    dispatch(getSingleBooking(b?.cAWB_No));
  };

  const columns = [
    {
      title: "AWB",
      dataIndex: "awbNumber",
      key: "awbNumber",
      // render: (text, record) => (
      //   <a onClick={() => handleEyeButton(record)}>{text} </a>
      // ),
    },
    {
      title: "CAWB",
      dataIndex: "cAwbNumber",
      key: "awbNumber",
      // render: (text, record) => (
      //   <a onClick={() => handleEyeButton(record)}>{text} </a>
      // ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => text?.replace(/_/g, " ") || "N/A",
    },
  ];

  const getPrsDetails = async () => {
    try {
      setLoading(true);
      const { response: { data: { data } = {} } = {} } = await API.Api(`${PRS_LIST}?PRSNumber=${id}`).getCustomHeader({
        kid: "1",
        authtype: "jwt"
      }) || {};

      if (data) {
        setPrsDetails(data?.prsList[0]);
        setTableData(data?.prsList[0].awbNumberList);
        setTotal(data?.prsList[0].awbNumberList.length);
      }
    } catch (error) {
      console.error("Error fetching PRS details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getPrsDetails();
    }
  }, [id]);

  function handleCancel() {
    setIsSummaryModalOpen(false);
  }

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("MM/DD/YYYY hh:mm A");
  };

  const handleAssignDA = (prsData) => {
    setSelectedPRS(prsData);
    setIsAssignDAModalOpen(true);
  };

  const handleCopyPRSNumber = () => {
    navigator.clipboard.writeText(id)
      .then(() => {
        message.success('PRS Number Copied To Clipboard');
      })
      .catch((err) => {
        message.error('Failed to copy PRS number');
      });
  };

  return (
    <div className="prs-details">
      <ViewBookingSummary
        visible={isSummaryModalOpen}
        loading={loading2}
        handleCancel={handleCancel}
        allAppData={singleResult}
        bookingType={bookingType}
        componentRef={componentRef}
      />
      <PRSAssignDA 
        isModalOpen={isAssignDAModalOpen}
        handleCancel={() => setIsAssignDAModalOpen(false)}
        prsData={selectedPRS}
        handleSuccess={getPrsDetails}
      />
      <Heading title="PRS Details" />
      <Row>
        <div className="prs-primary-details-row">
          <div className="box-left">
            <div className="prs-number-status">
              <div 
                className="prs-number-container" 
                onClick={handleCopyPRSNumber}
                style={{ cursor: 'context-menu' }}
              >
                {id}
              </div>
              <div className="prs-status-container">{prsStatus[prsDetails?.status]}</div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "1em",
                flexWrap: "wrap",
              }}
              className="prs-other-details-container"
            >
              <div style={{ flex: 1, minWidth: "250px" }}>
                <p>
                  Created On: &nbsp;&nbsp;&nbsp;
                  <span className="highlight">{formatDateTime(prsDetails?.createdDate)}</span>
                </p>
              </div>
              <div style={{ flex: 1, minWidth: "100px" }}>
                <p>
                  Weight: &nbsp;&nbsp;&nbsp;
                  <span className="highlight">
                    {prsDetails?.weight/1000 + " Kg" || "N/A"}
                  </span>
                </p>
              </div>
              <div style={{ flex: 1, minWidth: "200px" }}>
                <p>
                  No. Of Orders: &nbsp;&nbsp;&nbsp;
                  <span className="highlight">
                    {prsDetails?.awbNumberList?.length || "N/A"}
                  </span>
                </p>
              </div>
            </div>
          </div>
          {prsDetails?.status === 'PRS_PENDING' && !isDPOperator ? (
            <Button
              className="btn btn-primary"
              type="primary"
              onClick={() => handleAssignDA(prsDetails)}
            >
              Assign DA
            </Button>
          ) : prsDetails?.status !== 'PRS_PENDING' ? (
            <div className="assigned-da-info">
              <div className="da-name-info">
                <DaIcon />
                <div className="da-name-label">{prsDetails?.deliveryAgents?.length ? prsDetails?.deliveryAgents[0]?.name:'NA'}</div>
              </div>
              {prsDetails?.status == 'PRS_ASSIGN_TO_DA' && !isDPOperator && (
                <Tooltip title={"Reassign DA"} placement="bottom">
                  <div
                    className="pointer"
                    onClick={() => handleAssignDA(prsDetails)}
                    style={{ marginTop: "4px" }}
                  >
                    <DaEditIcon /> 
                  </div>
                </Tooltip>
              )}
            </div>
          ) : null}
        </div>
      </Row>
      <Row>
        <div className="prs-secondary-details-row">
          <div className="details-box">
            <div className="detail-label">Seller Name</div>
            <div className="detail-value">{prsDetails?.sellerInfo?.name || "N/A"} </div>
          </div>
          <div className="details-box">
            <div className="detail-label">Pickup From (Seller Address)</div>
            <div className="detail-value">{prsDetails?.pickupInfo?.address1 + " " + prsDetails?.pickupInfo?.address2 + ", " + prsDetails?.pickupInfo?.zip || "N/A"} </div>
          </div>
          <div className="details-box">
            <div className="detail-label">Hub Name</div>
            <div className="detail-value">{prsDetails?.dropInfo?.name || "N/A"} </div>
          </div>
          <div className="details-box">
            <div className="detail-label">Drop At (Hub Address)</div>
            <div className="detail-value">{prsDetails?.dropInfo?.address1 || "N/A"} </div>
          </div>
        </div>
      </Row>
      <Row>
        <Col span={24}>
          <div className="shipment-list-label">Shipment List</div>
          <TableContainer
            loading={loading}
            columns={columns}
            dataSource={tableData}
            pagination={false}
            scroll={{
              y: 400,
            }}
          />
      
        </Col>
      </Row>
    </div>
  );
};

export default CpPrsDetails;
